import React from 'react';
import cx from 'classnames';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import arrowRightSVG from 'fcmh/theme/assets/icons/arrow-right.svg';

const resolveLink = (val) => {
  if (!val) return '';
  if (typeof val === 'string') return val;
  if (Array.isArray(val)) return resolveLink(val[0]);
  if (val['@id']) return flattenToAppURL(val['@id']);
  if (val.url) return val.url;
  return '';
};

const safe = (s) => (typeof s === 'string' ? s : '');

const HeaderCopyright = ({ text }) => {
  const [open, setOpen] = React.useState(false);

  const clean = safe(text).trim();
  if (!clean) return null;

  const toggle = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    setOpen((o) => !o);
  };

  return (
    <div
      className={cx('fcmh-header__copyright', { 'is-open': open })}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className="fcmh-header__copyright-icon"
        aria-label="Bildnachweis anzeigen"
        aria-expanded={open}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            e.stopPropagation();
            setOpen(false);
          }
        }}
      >
        ©
      </button>

      <div className="fcmh-header__copyright-tooltip" role="tooltip">
        <span className="fcmh-header__copyright-text">{clean}</span>
      </div>
    </div>
  );
};

const HeaderView = ({ data = {}, isEditMode = false }) => {
  const image = data?.image?.[0]?.['@id']
    ? `${flattenToAppURL(data.image[0]['@id'])}/@@images/image`
    : null;

  const title = data.title || '';
  const description = data.description || '';
  const buttonLabel = data.button_label || '';
  const buttonLink = resolveLink(data.button_link);
  const isFullWidth = !!data.full_width;

  const copyrightText = data.copyright_text || '';

  const widthClass = isFullWidth ? 'fcmh-header--full-width' : '';

  return (
    <section className={`block fcmh-header ${widthClass}`}>
      {image && (
        <div className="fcmh-header__image-wrapper">
          <img
            src={image}
            alt={title || 'Header background'}
            className="fcmh-header__image"
          />
          <div className="fcmh-header__overlay" />
        </div>
      )}

      <HeaderCopyright text={copyrightText} />

      <div className="fcmh-header__content ui container">
        {title && <h1 className="fcmh-header__title">{title}</h1>}
        {description && (
          <p className="fcmh-header__description">{description}</p>
        )}

        {buttonLink && buttonLabel && (
          <UniversalLink
            href={buttonLink}
            className="fcmh-header__button"
            target="_blank"
            rel="noopener noreferrer"
            disabled={isEditMode}
          >
            <span>{buttonLabel}</span>
            <Icon name={arrowRightSVG} size="14px" />
          </UniversalLink>
        )}
      </div>
    </section>
  );
};

export default HeaderView;
